<template>
<button v-if="isType === 0"
        class="commons_button font-size-large"
        @click="callback"
        type="button">{{title}}</button>
<button v-else-if="isType === 1"
        class="commons-okay_button font-size-large"
        @click="callback"
        type="button"><slot></slot>{{title}}</button>
<button v-else-if="isType === 2"
        class="commons-cancel_button font-size-large"
        @click="callback"
        type="button"><slot></slot>{{title}}</button>
<button v-else-if="isType === 3"
        class="commons-disable_button font-size-large"
        type="button"><slot></slot>{{title}}</button>
<button v-else class="clear" type="button" @click="callback"><slot></slot></button>
</template>

<script>
export default {
  name: 'ButtonText',
  props: {
    title: {
      type: String,
      default: '',
    },
    callback: Function,
    isType: Number,
  },
};
</script>

<style lang="scss" scoped>
.font-size-large {
  font-size: 1rem;
  font-weight: 600;
}

.commons_button {
  background-color: rgb(255, 255, 255);
  border-radius: 50px;
  width: 100%;
  height: 100%;
  border: none;

  animation: button-fade-in 0.2s ease-in both;
}

.commons_button:hover {
  animation: button-fade-out 0.2s ease-in both;
}

.commons-okay_button {
  background-color: rgb(104, 180, 205);
  border-radius: 10px;
  width: 100%;
  height: 100%;
  border: none;

  animation: button-fade-in 0.2s ease-in both;
}

.commons-okay_button:hover {
  animation: button-fade-out 0.2s ease-in both;
}

.commons-cancel_button {
  background-color: rgb(255, 127, 107);
  color: rgb(255, 255, 255);
  border-radius: 10px;
  width: 100%;
  height: 100%;
  border: none;

  animation: button-cancel-fade-in 0.2s ease-in both;
}

.commons-cancel_button:hover {
  animation: button-cancel-fade-out 0.2s ease-in both;
}

.commons-disable_button {
  background-color: rgb(126, 126, 126);
  border-radius: 10px;
  width: 100%;
  height: 100%;
  border: none;
  color: rgb(255, 255, 255) !important;
}

.commons_text {
  color: rgb(255, 255, 255);
}

@keyframes button-fade-out {
  from {
    background-color: rgb(104, 180, 205);
    //border: rgb(255, 255, 255) 1px solid;
    color: rgb(255, 255, 255);
  }
  to {
    background-color: rgb(255, 255, 255);
    //border: rgb(104, 180, 205) 1px solid;
    color: rgb(104, 180, 205);
  }
}

@keyframes button-fade-in {
  from {
    background-color: rgb(255, 255, 255);
    //border: rgb(104, 180, 205) 1px solid;
    color: rgb(104, 180, 205);
  }
  to {
    background-color: rgb(104, 180, 205);
    //border: rgb(255, 255, 255) 1px solid;
    color: rgb(255, 255, 255);
  }
}

@keyframes button-cancel-fade-out {
  from {
    background-color: rgb(255, 127, 107);
    //border: rgb(255, 255, 255) 1px solid;
    color: rgb(255, 255, 255);
  }
  to {
    background-color: rgb(255, 255, 255);
    //border: rgb(104, 180, 205) 1px solid;
    color: rgb(255, 127, 107);
  }
}

@keyframes button-cancel-fade-in {
  from {
    background-color: rgb(255, 255, 255);
    //border: rgb(104, 180, 205) 1px solid;
    color: rgb(255, 127, 107);
  }
  to {
    background-color: rgb(255, 127, 107);
    //border: rgb(255, 255, 255) 1px solid;
    color: rgb(255, 255, 255);
  }
}

.clear {
  border: 0;
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutButtonText.vue